import { Directive, Output, EventEmitter, HostBinding, HostListener } from '@angular/core';

@Directive({
  selector: '[dragAndDrop]'
})
export class DragAndDropDirective {
  @Output() fileDrop = new EventEmitter<any>();
  @HostBinding('style.opacity') opacity = '1';

  @HostListener('dragover', ['$event'])
  handleDragOver(event: any) {
    event.preventDefault();
    event.stopPropagation();
    this.opacity = '0.5';
  }

  @HostListener('dragleave', ['$event'])
  handleDragLeave(event: any) {
    event.preventDefault();
    event.stopPropagation();
    this.opacity = '1';
  }

  @HostListener('drop', ['$event'])
  handleDrop(event: any) {
    event.preventDefault();
    event.stopPropagation();
    this.opacity = '1';
    const files = event.dataTransfer.files;
    if(files.length > 0)
      this.fileDrop.emit(files);
  }
}